export enum FormFieldLookupTypeDTO {
  None = 0,
  Internal,
  External,
}
